const Connect = require("react-redux").connect;
const Login = require("../components/Login");
const AuthAct = require("actions/auth");

const internals = {};

internals.connect = Connect(null, {
    login: AuthAct.login
});

module.exports = internals.connect(Login);



// WEBPACK FOOTER //
// ./src/routes/login/containers/Login.js